/**
 * Единый интерфейс над Я.Метрикой, GA4 и Clarity.
 * W1: stub. W3: реальная инициализация по ID из env.
 *
 * Все события из плана: hero_cta_click, sticky_cta_click, final_cta_click,
 * product_card_click, form_start, form_submit, form_success, form_error,
 * faq_open, scroll_25/50/75/100.
 */

type EventName =
  | 'hero_cta_click'
  | 'hero_calc_link_click'  // ссылка «посчитать рост маржи» с первого экрана
  | 'sticky_cta_click'
  | 'final_cta_click'
  | 'product_card_click'
  | 'ladder_cta_click'
  | 'form_start'
  | 'form_submit'
  | 'form_success'
  | 'form_error'
  | 'faq_open'
  | 'scroll_25'
  | 'scroll_50'
  | 'scroll_75'
  | 'scroll_100'
  | 'guide_download'      // клик по download-кнопке в гайде (артефакт типа .md)
  | 'architecture_cta_click'  // CTA блока «Почему не сами» (раньше — секция Positioning)
  | 'tracks_enterprise_cta_click'  // выбор трека «Внедрение Claude Enterprise»
  | 'tracks_core_cta_click'        // выбор трека «DNAI Core» (custom + доля)
  | 'partner_tg_click'             // клик в личку Антона из партнёрской секции
  | 'partner_cases_click'          // партнёр открыл видеокейсы, чтобы показать клиенту
  | 'partner_channel_click'        // партнёр открыл канал, чтобы показать клиенту
  | 'calc_plan_switch'              // выбор «сэкономить на ФОТ» vs «делегировать больше»
  | 'calc_mode_switch'             // переключение режима калькулятора ценности
  | 'calc_cta_click'               // CTA из калькулятора ценности
  | 'product_cta_click'            // «Обсудить проект» на карточке продукта
  | 'read_next_all_click'          // «Все гайды» в блоке «Читать дальше»
  | 'audience_tile_click'          // плитка «кому» на главной (параметр sector)
  | 'capability_link_click'        // ссылка в блоке «Как это устроено» (роль или шаг)
  | 'leadmagnet_click'             // плашка «методика стратегической сессии»
  | 'case_open'                    // «Разбор →» с карточки кейса на /keysy
  | 'review_video_click'           // видео-отзыв собственника у кейса до эпохи ИИ (параметр client) — главная и /keysy
  | 'case_cta_click'               // «Записаться на диагностику» со страницы кейса /keysy/<slug> (параметр case)
  | 'service_pricing_cta_click'    // контакт/CTA в блоке «Стоимость и условия» сервис-страниц

declare global {
  interface Window {
    ym?: (id: number, method: string, ...args: unknown[]) => void
    gtag?: (command: string, ...args: unknown[]) => void
    clarity?: (method: string, ...args: unknown[]) => void
    dataLayer?: unknown[]
  }
}

export function track(event: EventName, params: Record<string, unknown> = {}) {
  if (typeof window === 'undefined') return

  // Dev — просто лог, чтобы видеть события в консоли
  if (import.meta.env.DEV) {
    // eslint-disable-next-line no-console
    console.debug('[analytics]', event, params)
    return
  }

  // Я.Метрика
  const ymId = Number(import.meta.env.VITE_YM_ID)
  if (ymId && window.ym) {
    window.ym(ymId, 'reachGoal', event, params)
  }

  // GA4
  if (window.gtag) {
    window.gtag('event', event, params)
  }

  // Clarity — событий не принимает, но setTag под ключевые шаги полезен
  if (window.clarity && event === 'form_success') {
    window.clarity('set', 'lead', 'true')
  }
}

export function captureUtm(): Record<string, string> {
  if (typeof window === 'undefined') return {}
  const params = new URLSearchParams(window.location.search)
  const utm: Record<string, string> = {}
  for (const key of ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term']) {
    const v = params.get(key)
    if (v) utm[key] = v
  }
  if (document.referrer) utm.referrer = document.referrer
  return utm
}
